module.exports = __webpack_public_path__ + "static/media/circle-add-icon.608b44ab.svg";